/* Click-to-load map. The iframe (and so every request to Google) is only created after the visitor presses "Vis kort". */
(function () {
  if (window.frbMapLoader) return;
  window.frbMapLoader = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.frb-map__show');
    if (!button) return;
    var map = button.closest('[data-frb-map]');
    var stage = map && map.querySelector('.frb-map__stage');
    if (!stage) return;

    var iframe = document.createElement('iframe');
    iframe.src = map.getAttribute('data-frb-map-src');
    iframe.title = map.getAttribute('data-frb-map-title') || '';
    iframe.loading = 'lazy';
    iframe.referrerPolicy = 'no-referrer-when-downgrade';
    iframe.allowFullscreen = true;
    stage.textContent = '';
    stage.appendChild(iframe);
    map.classList.add('is-loaded');
  });
})();
